export default {
    title: 'Macro-trend',
    belongs: 'This trend belongs to mega-trend:',
    noTranslation: 'no English translation available'
}
